import React from "react";
import { DialogContentText } from "@mui/material";
import { useDispatch } from "react-redux";
import { IChannel } from "@Interfaces";
import { actions as dialogActions } from "@Store/Reducers/dialog";
import Avatar from "@mui/material/Avatar";
import useChannelProfileImg from "@Hooks/useChannelProfileImg";
import LoginForm from "@Components/LoginForm";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import JoinDialog from "@Components/InviteDialog/JoinDialog";

type InvitationProps = { channel?: IChannel };

const InvitationContent: React.FC<InvitationProps> = ({
    channel,
}: InvitationProps) => {
    const { title, profile_image } = channel || {};
    const isEventProfilePictureVisible =
        channel?.settings?.display_profile_picture ?? true;
    const channelProfileImage = useChannelProfileImg(
        isEventProfilePictureVisible ? profile_image?.public_url : undefined,
        isEventProfilePictureVisible ? profile_image?.fid : undefined
    );
    const dispatch = useDispatch<any>();
    const [openSignup, setOpenSignup] = React.useState(false);

    const handleOpenSignup = () => {
        setOpenSignup(true);
    };
    const handleClose = () => {
        dispatch(dialogActions.hideDialog());
    };

    const handlePreviousDialog = () => {
        setOpenSignup(false);
    };

    const handleCloseSignup = () => {
        setOpenSignup(false);
    };

    const handleCallback = (childData: boolean) => {
        if (childData) {
            handleCloseSignup();
        }
    };
    return (
        <>
            {channel && (
                <DialogContentText
                    sx={{
                        margin: "auto",
                        textAlign: "center",
                        color: "#2E4E76",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    You have been invited to join:
                    <Box
                        component="span"
                        sx={{
                            fontWeight: "bold",
                            color: "#2E4E76",
                            textTransform: "capitalize",
                        }}
                    >
                        {title}
                    </Box>
                    {isEventProfilePictureVisible ? (
                        <Avatar
                            component={"span"}
                            sx={{
                                width: "75px",
                                height: "75px",
                                backgroundColor: "transparent",
                                margin: "20px auto",
                            }}
                            src={channelProfileImage}
                        />
                    ) : null}
                </DialogContentText>
            )}
            <LoginForm />
            <Box
                component="span"
                onClick={handleOpenSignup}
                sx={{
                    margin: "-7px auto 16px",
                    textAlign: "center",
                    color: "#1fc2ff",
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "1.3em",
                    fontWeight: 500,
                    cursor: "pointer",
                    "&:hover": {
                        textDecoration: "underline",
                    },
                }}
            >
                Create an Account
            </Box>
            <Link
                href="#"
                onClick={handleClose}
                sx={{
                    margin: "auto",
                    textAlign: "center",
                    color: "#2E4E76",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                Continue as a guest
            </Link>
            <JoinDialog
                openSignup={openSignup}
                handleCloseSignup={handleCloseSignup}
                handlePreviousDialog={handlePreviousDialog}
                handleCallback={handleCallback}
            />
        </>
    );
};

const InvitationActions: React.FC<string> = (channel) => {
    return <></>;
};

export default {
    content: InvitationContent,
    actions: InvitationActions,
    title: "",
};
